module.exports = __webpack_public_path__ + "img/forte0001.7a9817b5.jpeg";